import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type ChatState = {
  activeChatUrl?: string;
};

const chatInitialState: ChatState = {};

export const { reducer: chatReducer, actions: chatActions } = createSlice({
  initialState: chatInitialState,
  name: 'chat',
  reducers: {
    deleteActiveChatUrl(state) {
      delete state.activeChatUrl;
    },
    setActiveChatUrl(state, action: PayloadAction<string>) {
      state.activeChatUrl = action.payload;
    },
  },
});
